module.exports = __webpack_public_path__ + "img/start.8c746700.png";